export default __webpack_public_path__ + "static/media/card-image-4.81f999e6.jpg";